export const ERROR_MSG = " Required";
export const IFSC_VALIDATION = /^[A-Z]{4}0[A-Z 0-9]{6}$/;

export const AADHAR_VALIDATION = /^[1-9]{1}[0-9]{11}$/;
export const MOBILE_VALIDATION = /^[6-9]{1}[0-9]{9}$/;
export const PAN_VALIDATION = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const PINCODE = /^[1-9]{1}[0-9]{5}$/;
export const ApPINCODE = /^5[0-9]{5}$/;

export const NUMERIC = /^\d+$/;
export const ALPHABETS_ONLY = /^[aA-zZ\s]+$/;
export const STARTS_WITH_NO_WHITESPACE = /^(?!\s+$).*/;
export const AC_YEAR_OLD = "2025-26";
export const AC_YEAR = "2026-27";
export const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const faxRegex = /^(\+91[\-]?)?(\d{2,4})-\d{6,8}$/;
export const pantanRegex = /^([A-Z]{5}[0-9]{4}[A-Z]|[A-Z]{4}[0-9]{5}[A-Z])$/i;



